import { useMutation } from '@tanstack/react-query'
import {
  submitToSalesforce,
  type SalesforceLeadPayload,
} from './submitToSalesforce'

export function useSubmitSalesforceLeadMutation() {
  const mutation = useMutation({
    mutationFn: (payload: SalesforceLeadPayload) => submitToSalesforce(payload),
  })

  return [
    mutation.mutateAsync,
    {
      isLoading: mutation.isPending,
      isError: mutation.isError,
      error: mutation.error,
      reset: mutation.reset,
    },
  ] as const
}
